export function first<T>(t: T[]): T | null {
  return isEmpty(t) ? null : t[0];
}

export function isEmpty(a: any[]): boolean {
  return !a || a.length === 0;
}

export function isNotEmpty(a: any[]): boolean {
  return !isEmpty(a);
}
